// extracted by mini-css-extract-plugin
var _1 = "k04cD";
var _2 = "yP587";
var _3 = "gmKiS";
var _4 = "t3sj0";
var _5 = "gP_tp";
export { _1 as "base", _2 as "overloaded", _3 as "pending", _4 as "started", _5 as "suspended" }
